import { render, staticRenderFns } from "./addnews.vue?vue&type=template&id=9d411816&scoped=true&"
import script from "./addnews.vue?vue&type=script&lang=js&"
export * from "./addnews.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./addnews.vue?vue&type=style&index=1&id=9d411816&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d411816",
  null
  
)

export default component.exports